import '.d{display:flex;}.ssr-plugin'
import '.af{align-items:stretch;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.db{background:var(--palette-white);}.ssr-plugin'
import '.c4{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b9{max-width:77.5rem;}.ssr-plugin'
import '.dh{justify-content:stretch;}.ssr-plugin'
import '.di{position:sticky;}.ssr-plugin'
import '.cb{top:0;}.ssr-plugin'
import '.dj{z-index:10;}.ssr-plugin'
import '.dk{padding-block:1rem;}.ssr-plugin'
import '.dl{height:3rem;}.ssr-plugin'
import '.a5{justify-content:space-between;}.ssr-plugin'
import '.dm{flex-wrap:wrap;}.ssr-plugin'
import '.dn{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.be{margin-top:2rem;}.ssr-plugin'
import '.gi{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d af i e db"
      >
        <div className="c4 d f i e"
        >
          <div className="b9 d e dh di cb dj"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dk dl d a5 f dm"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dn d e af be gi b9"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
